import * as angular from 'angular';
import {IController} from "angular";

export class ServiceTypeIndicationCtrl implements IController {
  serviceType: any;
  isShort: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTypeIndication', {
    bindings: {
      serviceType: '<',
      isShort: '<?'
    },
    template: require('./service-type-indication.html').default,
    controller: ServiceTypeIndicationCtrl
  });
